import * as Yup from "yup";
import { yupPassword, yupRepeatPassword } from "./yupRules";

export const newPasswordSchema = (t) =>
  Yup.object().shape({
    password: yupPassword(t),
    repeatPassword: yupRepeatPassword(t),
  });
